'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassNamePassthrough = function ClassNamePassthrough(_ref) {
  var children = _ref.children,
      className = _ref.className;

  if (children == null) return null;
  var child = _react2.default.Children.only(children);
  return _react2.default.cloneElement(child, {
    className: (0, _reactUtils.classNames)(child.props.className, className)
  });
};
ClassNamePassthrough.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
};

exports.default = ClassNamePassthrough;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/core/ClassNamePassthrough.js
// module id = 259
// module chunks = 0